import dayjs from 'dayjs';
import { ListConductorFilters } from '../list-conductor/filters';
import { AppliedFilters } from './interface';

export const getCumulativeFilterCount = (filters: AppliedFilters | ListConductorFilters) => {
  let count = 0;

  if (!filters || Object.keys(filters).length === 0) {
    return count;
  }

  Object.keys(filters).forEach((filter: string) => {
    const currentFilter = (filters as AppliedFilters)[filter];
    if (!currentFilter.value) {
      return;
    }

    count +=
      Array.isArray(currentFilter.value) && currentFilter.operator !== 'RANGE'
        ? currentFilter.value.length
        : 1;
  });
  return count;
};

export const getFiltersCount = (filter: { operator: string; value: unknown }) => {
  if (filter) {
    const { value: filterValue, operator } = filter;

    if (!filter.value) {
      return 0;
    }
    if (operator === 'RANGE') {
      return (filterValue as Array<string | number>).length > 0 ? 1 : 0;
    }

    return Array.isArray(filterValue) ? filterValue.length : 1;
  }
  return 0;
};

export const sanitizeRangeData = (value: unknown) => {
  const filterValue = value as Array<number | null>;
  if (!filterValue[0]) {
    filterValue[0] = dayjs(filterValue[1] || '01-01-1970')
      .subtract(1, 'year')
      .startOf('day')
      .valueOf();
  }

  if (!filterValue[1]) {
    filterValue[1] = dayjs().endOf('day').valueOf();
  }
  return filterValue;
};

export const FILTER_OPERATOR_SANITIZER_MAP: {
  [key: string]: (value: unknown) => unknown;
} = {
  RANGE: sanitizeRangeData
};
